export default __webpack_public_path__ + "static/media/defaultFemaleProfile.1931317d.jpg";